import type { ImageModalType } from '~/types'

/**
 * Returns an optimized conversion URL from the backend if available,
 * falling back to the original image URL.
 * Prevents Nuxt IPX from processing heavy 4000px+ raw camera originals.
 */
export const getOptimalImageUrl = (
  image?: ImageModalType | { url?: string; conversions?: any[] } | null,
  preferred: 'fhd' | 'mobile_lg' | 'mobile' = 'fhd',
): string => {
  if (!image) return ''

  const conversions = image.conversions || []
  if (!conversions.length) {
    return image.url || ''
  }

  const preferredMap: Record<string, string[]> = {
    fhd: ['webp_fhd', 'webp_mobile_lg', 'webp_1440', 'webp_mobile'],
    mobile_lg: ['webp_mobile_lg', 'webp_fhd', 'webp_mobile'],
    mobile: ['webp_mobile', 'webp_mobile_lg', 'webp_fhd'],
  }

  const searchOrder = preferredMap[preferred] || preferredMap.fhd

  for (const name of searchOrder) {
    const found = conversions.find((c: any) => c.name === name)
    if (found?.url) return found.url
  }

  return conversions[0]?.url || image.url || ''
}
